import * as queryString from "query-string";
import React from "react";
import { newsSourcesType } from "../../../common/types/search/news";

export function FullStory({ sources }: { sources: newsSourcesType }) {
	if (sources.size === 0) {
		return null;
	}

	const storyLineName = `Full ${sources.size === 1 ? "Story" : "Stories"}`;

	const generateNewsSourceLinks = (sources: newsSourcesType) => {
		const params = {
			origin: window.location.href,
		};
		return sources.map((source, i) => {
			const separator = i !== sources.size - 1 ? ", " : "";
			params.origin = source.get("url");
			// TODO: Check logic here
			// params.destination = source.get("url");
			const query = queryString.stringify(params);

			return (
				<span key={i}>
					<a href={`/external-link-warning?${query}`}>
						{source.get("name")}
					</a>
					{separator}
				</span>
			);
		});
	};

	const sourceLinks = generateNewsSourceLinks(sources);

	return (
		<p className="post__full-story">
			{storyLineName}: {sourceLinks}
		</p>
	);
}
